import { Component, Input } from "@angular/core";

@Component({
  moduleId: module.id,
  selector: "accessibility",
  templateUrl: "./accessibility.component.html",
})
export class AccessibilityComponent {
  @Input() public visible: boolean;
  constructor() {}
}



// WEBPACK FOOTER //
// ./src/app/addons/accessibility.component.ts